var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { ActivatedRoute, Router } from "@angular/router";
import { TranslateService } from "app/translate/translate.service";
import { FilterFormService } from "app/views/filter_form/filter_form.service";
import { HelperService } from "app/lib/helper.service";
import { ChartParams } from "app/views/chart/chart.component";
import { BaseComponent } from "app/views/base.component";
import { EventsService } from "app/lib/EventsService";
import { ModalService } from "app/views/modal/base_modal.component";
import { UserService } from "../user.service";
var ActivityComponent = /** @class */ (function (_super) {
    __extends(ActivityComponent, _super);
    function ActivityComponent(eventsService, helper, activatedRoute, translate, router, modalService, filter, userService) {
        var _this = _super.call(this, eventsService, userService, activatedRoute, filter, translate) || this;
        _this.eventsService = eventsService;
        _this.helper = helper;
        _this.activatedRoute = activatedRoute;
        _this.translate = translate;
        _this.router = router;
        _this.modalService = modalService;
        _this.filter = filter;
        _this.userService = userService;
        _this.oneDayChart = new ChartParams({
            type: 'bar',
            grid: {
                y: {
                    lines: [{ value: 0 }]
                }
            },
            axis: {
                x: {
                    type: 'category',
                    tick: {
                        culling: {
                            max: 10
                        }
                    }
                }
            }
        });
        _this.widgetChart = new ChartParams({
            type: 'bar',
            grid: {
                y: {
                    lines: [{ value: 0 }]
                }
            },
            axis: {
                x: {
                    type: 'category',
                    tick: {
                        culling: {
                            max: 30
                        }
                    }
                },
            }
        });
        _this.actionChart = new ChartParams({
            type: 'bar',
            grid: {
                y: {
                    lines: [{ value: 0 }]
                }
            },
            axis: {
                x: {
                    type: 'category',
                    tick: {
                        culling: {
                            max: 20
                        }
                    }
                },
            }
        });
        _this.widgetData = {};
        _this.actionData = {};
        _this.oneDayChart.setOptions({
            title: 'OneDay user activity',
            axis: {
                y: {
                    label: {
                        text: _this.translate.__A('users.graph.user percent'),
                        position: 'outer-middle'
                    }
                },
                x: {
                    label: {
                        text: _this.translate.__A('users.graph.hours'),
                        position: 'outer-middle'
                    }
                }
            },
            names: {
                'userCount': 'Users, (%)'
            }
        });
        _this.widgetChart.setOptions({
            title: _this.translate.__A('users.graph.about widgets'),
            axis: {
                x: {
                    label: _this.translate.__A('users.graph.widget-count'),
                },
                y: {
                    label: _this.translate.__A('users.graph.site-count'),
                }
            },
            names: {
                'count': _this.translate.__A('users.graph.Distribution by widget count'),
            }
        });
        _this.actionChart.setOptions({
            title: _this.translate.__A('users.graph.about actions'),
            type: 'bar',
            axis: {
                x: {
                    label: _this.translate.__A('users.graph.action-count'),
                },
                y: {
                    label: _this.translate.__A('users.graph.user-count'),
                }
            },
            names: {
                'count': _this.translate.__A('users.graph.Distribution by action count'),
            }
        });
        return _this;
    }
    ActivityComponent.prototype.getData = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getOneDayChart()];
                    case 1:
                        _a.sent();
                        return [4 /*yield*/, this.getWidgetChart()];
                    case 2:
                        _a.sent();
                        return [4 /*yield*/, this.getActionChart()];
                    case 3:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    ActivityComponent.prototype.getOneDayChart = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _a, charts, userCount;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        this.oneDayChart.showLoader();
                        return [4 /*yield*/, this.userService.activity.get(this.filter.filterParams, 'oneday').toPromise()];
                    case 1:
                        _a = _b.sent(), charts = _a.charts, userCount = _a.userCount;
                        this.oneDayChart.data = charts;
                        this.oneDayUserCount = userCount;
                        this.oneDayChart.hideLoader();
                        return [2 /*return*/];
                }
            });
        });
    };
    ActivityComponent.prototype.getWidgetChart = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _a, charts, totals, categories;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        this.widgetChart.showLoader();
                        return [4 /*yield*/, this.userService.activity.chart(this.filter.getCopyFilterParams({
                                widgetStartCount: this.widgetData.startCount,
                                widgetEndCount: this.widgetData.endCount,
                                widgetBorder: this.widgetData.border
                            }), 'widget').toPromise()];
                    case 1:
                        _a = _b.sent(), charts = _a.charts, totals = _a.totals, categories = _a.categories;
                        this.widgetChart.data = charts;
                        this.widgetChart.setOptions({
                            axis: {
                                x: {
                                    categories: categories,
                                }
                            }
                        });
                        this.widgetData = totals;
                        this.widgetChart.hideLoader();
                        return [2 /*return*/];
                }
            });
        });
    };
    ActivityComponent.prototype.getActionChart = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _a, charts, totals, categories;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        this.actionChart.showLoader();
                        return [4 /*yield*/, this.userService.activity.chart(this.filter.getCopyFilterParams({
                                activityStartCount: this.actionData.startCount,
                                activityEndCount: this.actionData.endCount,
                                activityBorder: this.actionData.border
                            }), 'activity').toPromise()];
                    case 1:
                        _a = _b.sent(), charts = _a.charts, totals = _a.totals, categories = _a.categories;
                        this.actionChart.data = charts;
                        this.actionChart.setOptions({
                            axis: {
                                x: {
                                    categories: categories,
                                }
                            }
                        });
                        this.actionData = totals;
                        this.actionChart.hideLoader();
                        return [2 /*return*/];
                }
            });
        });
    };
    ActivityComponent.prototype.customApplyFilters = function (type) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!(type == 'widget')) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.getWidgetChart()];
                    case 1:
                        _a.sent();
                        return [3 /*break*/, 4];
                    case 2:
                        if (!(type == 'action')) return [3 /*break*/, 4];
                        return [4 /*yield*/, this.getActionChart()];
                    case 3:
                        _a.sent();
                        _a.label = 4;
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    ActivityComponent.prototype.customResetFilters = function (type) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!(type == 'widget')) return [3 /*break*/, 2];
                        this.widgetData = {};
                        return [4 /*yield*/, this.getWidgetChart()];
                    case 1:
                        _a.sent();
                        return [3 /*break*/, 4];
                    case 2:
                        if (!(type == 'action')) return [3 /*break*/, 4];
                        this.actionData = {};
                        return [4 /*yield*/, this.getActionChart()];
                    case 3:
                        _a.sent();
                        _a.label = 4;
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    return ActivityComponent;
}(BaseComponent));
export { ActivityComponent };
